/**
 * Every action related to analytics will be stored here as a helper function
 */
import ReactGA from "react-ga4";

import { GOOGLE_MEASURMENT_ID } from "@/config/config";

/**
 * Initialize Google Analytics
 */
export const initializeGA = () => {
  ReactGA.initialize(GOOGLE_MEASURMENT_ID);
};

/**
 *  Push Page Tracking on Google Analytics
 *
 */
export const pageView = (pageTitle) => {
  //   Not supported with react-ga4 library.
  //   ReactGA.pageView(window.location.pathname + window.location.search);
  //   However, can send pageview as below
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: pageTitle,
  });
};

/**
 * Event - Add custom tracking event.
 * @param {string} category
 * @param {string} action
 * @param {string} label
 */
export const addGaEvent = (category, action, label) => {
  ReactGA.event({
    category,
    action,
    label,
  });
};

export const sendErrorAnalytics = (config, label) => {
  const category = "renewal";
  const action = config?.url;
  ReactGA.event({
    category,
    action,
    label,
  });
};

export const sendAxiosDefaultErrorAnalytics = (category, config, label) => {
  const action = config?.url;

  ReactGA.event({
    category,
    action,
    label,
  });
};
